
jQuery(document).ready(function(){
    if (window.matchMedia('(max-width: 767px)').matches) {
        jQuery('.steps-col.img-step.img-step-1').insertBefore('.steps-col.count-col.count-col-1');
        jQuery('.steps-col.img-step.img-step-2').insertBefore('.steps-col.count-col.count-col-2');
        jQuery('.steps-col.img-step.img-step-3').insertBefore('.steps-col.count-col.count-col-3');
        jQuery('.steps-col.img-step.img-step-4').insertBefore('.steps-col.count-col.count-col-4');
        jQuery('.steps-col.img-step.img-step-5').insertBefore('.steps-col.count-col.count-col-5');
        jQuery('.steps-col.img-step.img-step-6').insertBefore('.steps-col.count-col.count-col-6');
        jQuery('.steps-col.img-step.img-step-7').insertBefore('.steps-col.count-col.count-col-7');
        jQuery('.steps-col.img-step.img-step-8').insertBefore('.steps-col.count-col.count-col-8');
        jQuery('.steps-col.img-step.img-step-9').insertBefore('.steps-col.count-col.count-col-9');
        jQuery('.steps-col.img-step.img-step-10').insertBefore('.steps-col.count-col.count-col-10');
        // jQuery('.steps-col.img-step.img-step-11').insertBefore('.steps-col.count-col.count-col-11');
        jQuery('.steps-col.img-step.img-step-12').insertBefore('.steps-col.count-col.count-col-12');

    } 
    jQuery(".btt-btn i").click(function () {
        jQuery("html, body").animate({scrollTop: 0}, 1000);
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const accordionItems = document.querySelectorAll(".acc-item");

    accordionItems.forEach((item) => {
        const title = item.querySelector(".acc-item h3");
        const content = item.querySelector(".acc-item p");
        const chevron = item.querySelector(".acc-chevron");

        title.addEventListener("click", () => {
        // Close all accordion items except the clicked one
        accordionItems.forEach((otherItem) => {
            if (otherItem !== item) {
            const otherContent = otherItem.querySelector(".acc-item p");
            const otherChevron = otherItem.querySelector(".acc-chevron");
            otherContent.style.display = "none";
            otherChevron.style.transform = "rotate(0deg)";
            }
        });

        // Toggle display and chevron rotation for the clicked item
        const isExpanded = content.style.display === "block";
        content.style.display = isExpanded ? "none" : "block";
        chevron.style.transform = isExpanded ? "rotate(0deg)" : "rotate(180deg)";
        });
    });
});
